import React, { useState, useEffect } from "react";
import { Card, Title, Button, Flex, Text, Divider } from "@tremor/react";

import OAuthClientTable from "./table";
import OAuthDrawer from "../../../components/OAuthDrawer";
import * as oauthAPI from "../../../services/oauth";
import DeleteConfirm from "../../../components/DeleteConfirm";

// Version of OAuthClients component without Nav element for use within Admin page
export default function AdminOAuthClients() {
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [clientToDelete, setClientToDelete] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(null);

  const fetchClients = async () => {
    setIsLoading(true);
    try {
      const response = await oauthAPI.getOAuthClients();
      setClients(response);
    } catch (error) {
      console.error("Error fetching OAuth clients:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const handleAddClient = () => {
    setSelectedClientId(null);
    setDrawerOpen(true);
  };

  const handleEditClient = (client) => {
    setSelectedClientId(client.clientId);
    setDrawerOpen(true);
  };

  const handleDeleteClick = (client) => {
    setClientToDelete(client);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!clientToDelete) return;
    
    try {
      await oauthAPI.deleteOAuthClient(clientToDelete.clientId);
      fetchClients(); // Refresh list after deletion
    } catch (error) {
      console.error("Error deleting client:", error);
    } finally {
      setDeleteDialogOpen(false);
      setClientToDelete(null);
    }
  };

  const handleSaveClient = () => {
    fetchClients();
  };

  return (
    <div>
      <Flex justifyContent="between" alignItems="center">
        <div>
          <Title>OAuth Clients</Title>
          <Text>Manage your OIDC application clients</Text>
        </div>
        <Button onClick={handleAddClient}>
          Add Client
        </Button>
      </Flex>
      <Divider />
      <Card className="mt-6">
        <OAuthClientTable 
          clients={clients} 
          isLoading={isLoading} 
          onEdit={handleEditClient}
          onDelete={handleDeleteClick}
        />
      </Card>
      
      <DeleteConfirm
        isOpen={deleteDialogOpen}
        closeModal={() => setDeleteDialogOpen(false)}
        onConfirm={handleDeleteConfirm}
        message={`Are you sure you want to delete the client "${clientToDelete?.name}"? This will invalidate all access tokens and user sessions associated with this client.`}
      />

      <OAuthDrawer 
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        clientId={selectedClientId}
        onSave={handleSaveClient}
      />
    </div>
  );
}